import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

export type ListItemAvatarElement = FlexElement;
export interface ListItemAvatarProps extends FlexProps {
  avatar?: React.ReactNode | React.ReactNode[];
}
export const ListItemAvatar = styled(
  forwardRef<ListItemAvatarElement, ListItemAvatarProps>(({ avatar, ...restProps }, ref) => {
    if (!avatar) return null;
    return (
      <Flex ref={ref} maxHeight="40" maxWidth="40" {...restProps}>
        {avatar}
      </Flex>
    );
  })
).withConfig({
  displayName: 'ListItemAvatar',
})``;
